<script setup lang="ts">
import AppButton from "@/components/ui-kit/button/AppButton.vue";

withDefaults(defineProps<{
	title?: string,
	description?: string,
	cancelLabel?: string,
	confirmLabel?: string,
}>(), {
	title: 'Подтвердите действие',
	description: '',
	cancelLabel: 'Отмена',
	confirmLabel: 'Подтвердить',
})

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()
</script>

<template>
	<div class="confirm-action">
		<div class="confirm-action__title">
			{{ title }}
		</div>
		<div class="confirm-action__description">
			{{ description }}
		</div>
		<div class="confirm-action__actions">
			<app-button
				class="confirm-action__actions-button"
				type="secondary"
				:label="cancelLabel"
				@click="emit('cancel')"
			/>
			<app-button
				class="confirm-action__actions-button"
				:label="confirmLabel"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.confirm-action {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
	}

	&__description {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		text-align: center;
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
